import React from 'react'

import Node from './Node'

const FlowLog = props => {
	let {
		value,
		field: {
			buttonHandle, // 按钮点击处理函数，参数为 (button, log, allLogs)，button为按钮配置，log为当前日志，allLogs为所有日志
		}
	} = props

	value ??= []

	return <div className='t-flowlog-wrap'>
		{value.map((log, index) => (<Node key={index} prev={value[index - 1]} first={index === 0} last={index == value.length - 1}
			log={log} allLogs={value} buttonHandle={buttonHandle}
		/>))}
	</div >
}

export default FlowLog